<template>
  <div
    v-if="open"
    :class="['overlay', local ? 'overlay-absolute' : 'overlay-fixed']"
  >
    <div class="loader-container">
      <div class="loader"></div>
      <p class="loader-text">{{ text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomLoader",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "Загрузка данных...",
    },
    local: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 9999;
  left: 0;
  right: 0;
  bottom: 0;
}

.overlay-fixed {
  position: fixed;
  top: 44px;
}

.overlay-absolute {
  position: absolute;
  top: 0;
}

.loader-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.loader {
  border: 8px solid #ffffff;
  border-top: 8px solid #000000;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

.loader-text {
  color: #ffffff;
  font-weight: 500;
}

/* @keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
} */
</style>
